import {Provider, createContext, useContext} from 'react';

export const createRequiredContext =
    <N extends string>(name: N) =>
    <T>() => {
        const sentinel = Symbol();
        const context = createContext<T | typeof sentinel>(sentinel);

        function useRequiredContext(strict?: true): T;
        function useRequiredContext(strict?: false): T | null;
        function useRequiredContext(strict = true): T | null {
            const contextValue = useContext(context);

            if (contextValue !== sentinel) {
                return contextValue;
            }
            if (strict) {
                throw new Error(`No provider for strict context "${name}"`);
            } else {
                return null;
            }
        }

        type ProviderReturn = {
            [_ in `${N}Provider`]: Provider<T>;
        };
        type HookReturn = {
            [_ in `use${N}`]: typeof useRequiredContext;
        };
        return {
            [`${name}Provider`]: context.Provider,
            [`use${name}`]: useRequiredContext,
        } as Readonly<ProviderReturn & HookReturn>;
    };
